export default "__VITE_ASSET__Cr0xmS33__"